import { render, staticRenderFns } from "./GameHeading.vue?vue&type=template&id=4e9c7c7f&scoped=true"
import script from "./GameHeading.vue?vue&type=script&lang=js"
export * from "./GameHeading.vue?vue&type=script&lang=js"
import style0 from "./GameHeading.vue?vue&type=style&index=0&id=4e9c7c7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9c7c7f",
  null
  
)

export default component.exports